import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { useGridStyles } from "@/pages/laboratory/styles/gridStyles";
import { useContextMenuMESF } from "@dexteel/mesf-core";
import { Button, Grid2 as Grid, Typography } from "@mui/material";
import {
	DefaultMenuItem,
	GetContextMenuItemsParams,
	GridApi,
	MenuItemDef,
} from "ag-grid-community";

import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { useBucketsOptionsFunctions } from "../hooks/useBucketsOptionsFunctions";
import { useTableData } from "../hooks/useTableData";
import { CreateBucket } from "./CreateBucket";
import { DeleteBucket } from "./DeleteBucket";
import { EditBucket } from "./EditBucket";

type Props = {
	getBucketsFromAPI: Function;
	isLoading: boolean;
};

export const TableBucket = ({ getBucketsFromAPI, isLoading }: Props) => {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [bucketId, setBucketId] = useState<number | null>(null);
	const [gridApi, setGridApi] = useState<GridApi | null>(null);
	const [quickFilterText, setQuickFilterText] = useState("");

	const { getMenuOptions } = useBucketsOptionsFunctions({
		setBucketId,
		setShowEditModal,
		setShowDeleteModal,
		setShowCreateModal,
	});

	const { showContextMenu, registerConfig, show } = useContextMenuMESF();

	const { rows, columnDefs, defaultColDef } = useTableData({
		setBucketId,
		setShowEditModal,
		setShowDeleteModal,
		showContextMenu,
	});

	const onRowDoubleClicked = (event: any) => {
		setBucketId(event.data.BucketId);
		setShowEditModal(true);
	};

	const getContextMenuItems = React.useCallback(
		(params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
			const data = params.node?.data;
			showContextMenu(event as any, data, "bucketsContext");
			return [];
		},
		[rows],
	);

	useEffect(() => {
		registerConfig({
			id: "bucketsContext",
			getOptions: getMenuOptions,
		});
	}, []);

	const classes = useGridStyles();

	return (
		<>
			<Grid size={{ xs: 12 }} container justifyContent="center" spacing={1}>
				<Grid size={{ xs: 12 }}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Buckets
					</Typography>
				</Grid>

				<Grid
					size={{ xs: 12 }}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid size={{ xs: 12 }} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search buckets"
						/>
					</Grid>
					<Grid
						size={{ xs: 12 }}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columnDefs}
								onGridReady={(params) => setGridApi(params.api)}
								loading={isLoading}
								getContextMenuItems={getContextMenuItems}
								onRowDoubleClicked={onRowDoubleClicked}
								quickFilterText={quickFilterText}
								getRowId={(params) => params.data.BucketId}
								rowSelection="single"
							/>
						</div>
					</Grid>

					<Grid size={{ xs: 12 }} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW BUCKET
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<CreateBucket
				show={showCreateModal}
				onHide={(shouldUpdate: boolean) => {
					setShowCreateModal(false);
					if (shouldUpdate) getBucketsFromAPI();
				}}
				refreshData={getBucketsFromAPI}
			/>
			<EditBucket
				show={showEditModal}
				onHide={(shouldUpdate: boolean) => {
					setShowEditModal(false);
					setBucketId(null);
					if (shouldUpdate) getBucketsFromAPI();
				}}
				BucketId={bucketId}
			/>
			<DeleteBucket
				show={showDeleteModal}
				onHide={(shouldUpdate: boolean) => {
					setShowDeleteModal(false);
					setBucketId(null);
					if (shouldUpdate) getBucketsFromAPI();
				}}
				BucketId={bucketId}
			/>
		</>
	);
};
